import { render, staticRenderFns } from "./ItemServico.vue?vue&type=template&id=44dff9b1"
import script from "./ItemServico.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemServico.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports